import {httpRequest} from "../../../utils/HttpRequest";
import {IDictSearch,IDictParsms,IDictDetail,IDictInsert,IDictUpdata,IDictRemove,IDictDisable} from "./dictTypes"
import {IPage} from "../../../types/FmsTypes";

class DictService {
    async page(params:IDictSearch){
        const apiUrl = "/md/dict/page"
        return await httpRequest.post<IPage<IDictDetail>>(apiUrl,params)
    }
    async insert(params:IDictInsert){
        const apiUrl = "/md/dict/insert"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async update(params:IDictUpdata){
        const apiUrl = "/md/dict/update"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async remove(params:IDictRemove){
        const apiUrl = "/md/dict/remove"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async disable(params:IDictDisable){
        const apiUrl = "/md/dict/disable"
        return await httpRequest.post<boolean>(apiUrl,params)
    }    
}
const dictService = new DictService()
export {
    dictService
}